<template>
    <div class="group-manage layout-sub-page">
        <!-- 1. 顶部标题栏 -->
        <title-bar v-bind:titleData="titleData" v-bind:backFunc="clickBack" v-bind:createFunc="clickCreate"></title-bar>

        <!-- 2. 分组数据列表 -->
        <group-list></group-list>
        
        <!-- 3. 分组管理底部操作栏 -->
        <group-bottom-bar></group-bottom-bar>

        <!-- 4. 新建分组弹框 -->
        <van-dialog v-model="showCreate" title="新建分组" confirmButtonText='确定' v-bind:before-close="beforeClose" show-cancel-button closeOnClickOverlay>
            <div class="create-group-input">
                <input type="text" v-model="inputGroup" placeholder="请输入分组名字" maxlength="17" v-to-focus-group-manage='true' autofocus >
            </div>
        </van-dialog>

        <!-- 5. 批量修改批盘分组弹框 -->
        <van-popup :value="showChangeGroup" position="bottom" @click-overlay="clickCancel">
            <div class="van-hairline--top-bottom van-picker__toolbar">
                <span class="van-picker__cancel" @click.passive="clickCancel">取消</span>
                <span class="van-picker__confirm" @click.passive="clickConfirm">确定</span>
            </div>
            <van-picker :columns="groupDataList" @change="onChange"></van-picker>
        </van-popup> 
    </div>
</template>


<script>
import { RECORD_DOM } from '../../modules/dom'
import TitleBar from '../../components/TitleBar.vue'
import GroupList from '../../layouts/group/GroupList.vue'
import GroupBottomBar from '../../layouts/group/GroupBottomBar.vue'
import { MIX } from '../../modules/utils';

export default {
    name: 'GroupManage',
    components: { TitleBar, GroupList, GroupBottomBar },
    directives : {
        "to-focus-group-manage" : function (el, binding) {
            if(binding.value){
                setTimeout(() => { el.focus() }, 300);
            }
        }
    },
    computed: {
        groupDataList() {
            return this.$store.state.group.groupDataList;
        },
        showChangeGroup() {
            return this.$store.state.group.showChangeGroup;
        }
    },
    data() {
        return {
            inputGroup: '',
            showCreate: false,
            titleData: {'titleText': '分组管理', 'titleCreate': '新建', 'showCancel': false},
            groupChanged: false
        }
    },
    mounted: function() {
        setTimeout(() => {
            this.$el.style.width = window.innerWidth + 'px';
            this.$el.style.height = window.innerHeight + 'px';
            RECORD_DOM.setRecordListContentHide();
            MIX.trackPageViewed('GroupManager');
        }, 20);
    },
    methods: {
        clickBack() {
            this.$router.replace('/record');
            RECORD_DOM.resetRecordListContentStyle();
            RECORD_DOM.resetRecordLetterSideBarStyle();
        },
        clickCreate() {
            this.showCreate = true;
            this.inputGroup = "";
        },
        beforeClose(action, done) {
            if (action === 'confirm') {
                if(this.inputGroup != ''){
                    this.$store.dispatch('group/addGroup', this.inputGroup);
                    done();
                }else {
                    this.$toast("名称不能为空");
                    done();
                }
            } else {
                done();
            }
        },
        clickCancel() {
            this.$store.dispatch('group/toggleChangeGroup', false);
        },
        clickConfirm() {
            this.$store.dispatch('group/toggleChangeGroup', false);
            // 没有滚动的时候,初始化第一个id为新ID
            if(!this.groupChanged){
                this.$store.state.group.newGroupId = this.groupDataList[0].value;
            }
            this.$store.dispatch('group/changeGroup', this.$store.state.group.newGroupId);
        },
        onChange(picker, values) {
            this.groupChanged = true;
            this.$store.state.group.newGroupId = values.value;
        }

    }
}
</script>